/* ============================================================
   JapanSolved™ RLCS SUBTLE SHARE ANCHOR™
   FIXED56 optional behavior layer

   Uses native Web Share API when available.
   Falls back to copying the article URL to clipboard.
   ============================================================ */

(function () {
  if (window.__jsRlcsShareAnchorInitialized) return;
  window.__jsRlcsShareAnchorInitialized = true;

  document.addEventListener('click', async function (event) {
    var button = event.target.closest('[data-js-rlcs-share]');
    if (!button) return;

    var url = button.getAttribute('data-share-url') || window.location.href;
    var title = button.getAttribute('data-share-title') || document.title;
    var label = button.querySelector('.js-rlcs-share-label');
    var originalLabel = label ? (label.textContent || 'Share') : 'Share';

    try {
      if (navigator.share) {
        await navigator.share({ title: title, url: url });
        return;
      }

      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(url);
        if (label) {
          label.textContent = 'Copied';
          window.setTimeout(function () {
            label.textContent = originalLabel;
          }, 1400);
        }
      }
    } catch (error) {
      if (label) label.textContent = 'Share';
    }
  });
})();
